import { FormListComponent } from "app/shared/components/form-list/form-list.component";
import { PartnerInfoComponent } from "app/shared/components/partner-info/partner-info.component";
import { AsideBarComponent } from "app/shared/components/aside-bar/aside-bar.component";
import { AccordionComponent } from "app/common/accordion/accordion.component";
import { SelectButtonsComponent } from "app/common/select-buttons/select-buttons.component";
import { HorizontalSelectButtonComponent } from "app/common/horizontal-select-button/horizontal-select-button.component";
import { WorkflowStepsComponent } from "app/common/workflow-steps/workflow-steps.component";
import { MenuBarMobileComponent } from "app/common/menu-bar-mobile/menu-bar-mobile.component";
import { LabelsEditBatchesComponent } from "app/common/labels-edit-batches/labels-edit-batches.component";
import { LabelsEditComponent } from "app/common/labels-edit/labels-edit.component";
import { appModuleDeclarations } from "app/app.module.declarations";
import { ButtonAddComponent } from "app/shared/components/buttons/button-add/button-add.component";
import { ButtonBaseComponent } from "app/shared/components/buttons/button-base.component";
import { ButtonDeleteComponent } from "app/shared/components/buttons/button-delete/button-delete.component";
import { ButtonRadioTwoComponent } from "app/shared/components/buttons/button-radio-two/button-radio-two.component";
import { ButtonEditComponent } from "app/shared/components/buttons/button-edit/button-edit.component";
import { ButtonComponent } from "app/shared/components/buttons/button/button.component";
import { ButtonPrimaryComponent } from "app/shared/components/buttons/button-primary/button-primary.component";
import { ButtonLinkComponent } from "app/shared/components/buttons/button-link/button-link.component";
import { NotificationBaseComponent } from "app/shared/components/notifications/notification-base.component";
import { NotificationAlertBoxAdultChildComponent } from "app/shared/components/notifications/notification-alert-box-adult-child/notification-alert-box-adult-child.component";
import { NotificationAlertBoxComponent } from "app/shared/components/notifications/notification-alert-box/notification-alert-box.component";
import { CardsItemsListComponent } from "app/shared/components/cards-items-list/cards-items-list.component";
import { IncomeInfoEditComponent } from "app/common/income-info-edit/income-info-edit.component";
import { AdditionalIncomeFormFreelanceComponent } from "app/modules/statement/components/additional-income-form/additional-income-form-freelance/additional-income-form-freelance.component";
import { AdditionalIncomeFormCryptocurrencyComponent } from "app/modules/statement/components/additional-income-form/additional-income-form-cryptocurrency/additional-income-form-cryptocurrency.component";
import { AdditionalIncomeFormPensionComponent } from "app/modules/statement/components/additional-income-form/additional-income-form-pension/additional-income-form-pension.component";
import { AdditionalIncomeFormSocialComponent } from "app/modules/statement/components/additional-income-form/additional-income-form-social/additional-income-form-social.component";
import { ButtonOutlinePrimaryComponent } from "app/shared/components/buttons/button-outline-primary/button-outline-primary.component";
import { NotificationAlertBoxRiesterComponent } from "app/shared/components/notifications/notification-alert-box-riester/notification-alert-box-riester.component";
import { ConfirmCancelDialogComponent } from "app/shared/components/confirm-cancel-dialog/confirm-cancel-dialog.component";
import { UserChangePasswordDialogComponent } from "app/shared/components/user-change-password-dialog/user-change-password-dialog.component";
import { StatementProgressPipe } from "app/shared/pipes/statement-progress.pipe";
import { FilterPipe } from "app/shared/pipes/filter.pipe";
import { ButtonFillPrimaryComponent } from "app/shared/components/buttons/button-fill-primary/button-fill-primary.component";
import { ToolsBarComponent } from "app/shared/components/tools-bar/tools-bar.component";
import { QuestionWithOptionsComponent } from "app/core/components/question-with-options/question-with-options.component";
import { AdvisorContactStepComponent } from "app/core/components/advisor-contact-step/advisor-contact-step.component";
import { PremiumAcceptanceComponent } from "app/core/components/premium-acceptance/premium-acceptance.component";
import { MathRoundPipe } from "app/shared/pipes/math-round.pipe";
import { BoolValueChooser } from "app/shared/components/bool-value-chooser/bool-value-chooser.component";
import { AddValueList } from "app/shared/components/add-value-list/add-value-list.component";
import { SectionTitle } from "app/shared/components/section-title/section-title.component";
import { IncomeList } from "app/modules/statement/components/additional-income-form/additional-income-form-freelance/forms-elements/income-list/income-list.component";
import { IncomeInput } from "app/modules/statement/components/additional-income-form/additional-income-form-freelance/forms-elements/income-input/income-input.component";
import { IncomeEdit } from "app/modules/statement/components/additional-income-form/additional-income-form-freelance/forms-elements/income-edit/income-edit.component";

import { SectionTitleH3Component } from "app/shared/components/section-title-h3/section-title-h3.component";
import { AddAttachmentListComponent } from "app/shared/components/add-attachment/add-attachment-list.component";
import { ButtonAddTwoComponent } from "app/shared/components/buttons/button-two/button-two.component";
import { NewMessageDialogComponent } from "app/common/send-message-dialog/send-message-dialog.component";
import { MiniHamburgerMenuComponent } from "app/shared/components/mini-hamburger-menu/mini-hamburger-menu.component";
import { ForceChangePasswordComponent } from "app/shared/components/force-change-password-dialog/force-change-password-dialog.component";
import { TwoFactorSetUpDialogComponent } from "app/shared/components/2fa-dialog/2fa-set-up-dialog.component";
import { AdditionalIncomeFormVatComponent } from "app/modules/statement/components/additional-income-form/additional-income-form-vat/additional-income-form-vat.component";
import { SimplePercentFieldComponent } from "app/shared/components/simple-percent-field/simple-percent-field.component";
import { OptionalIncomeFieldsComponent } from "app/shared/components/optional-income-fields/optional-income-fields.component";
import { ComplexPercentFieldComponent } from "app/shared/components/complex-percent-field/complex-percent-field.component";
import { YousignComponent } from "app/shared/components/yousign-iframe/yousign.component";
export const sharedModuleDeclarations = [
  UserChangePasswordDialogComponent,
  FilterPipe,
  FormListComponent,
  PartnerInfoComponent,
  AsideBarComponent,
  ToolsBarComponent,
  QuestionWithOptionsComponent,
  AdvisorContactStepComponent,
  PremiumAcceptanceComponent,
  AccordionComponent,
  SelectButtonsComponent,
  HorizontalSelectButtonComponent,
  WorkflowStepsComponent,
  MenuBarMobileComponent,
  LabelsEditBatchesComponent,
  LabelsEditComponent,
  ButtonBaseComponent,
  ButtonDeleteComponent,
  ButtonAddComponent,
  ButtonRadioTwoComponent,
  ButtonEditComponent,
  ButtonComponent,
  ButtonFillPrimaryComponent,
  ButtonPrimaryComponent,
  ButtonLinkComponent,
  ButtonOutlinePrimaryComponent,
  NotificationBaseComponent,
  NotificationAlertBoxAdultChildComponent,
  NotificationAlertBoxRiesterComponent,
  NotificationAlertBoxComponent,
  FormListComponent,
  CardsItemsListComponent,
  StatementProgressPipe,
  MathRoundPipe,
  ConfirmCancelDialogComponent,
  IncomeInfoEditComponent, // TODO move to statement module
  AdditionalIncomeFormFreelanceComponent, // TODO move to statement module
  AdditionalIncomeFormCryptocurrencyComponent, // TODO move to statement modulez
  AdditionalIncomeFormPensionComponent, // TODO move to statement module
  AdditionalIncomeFormSocialComponent, // TODO move to statement module
  AdditionalIncomeFormVatComponent, // TODO move to statement module
  BoolValueChooser,
  AddValueList,
  SectionTitle,
  IncomeInput,
  IncomeList,
  IncomeEdit,
  SectionTitleH3Component,
  YousignComponent,
  NewMessageDialogComponent,
  AddAttachmentListComponent,
  ButtonAddTwoComponent,
  MiniHamburgerMenuComponent,
  ForceChangePasswordComponent,
  TwoFactorSetUpDialogComponent,
  SimplePercentFieldComponent,
  ComplexPercentFieldComponent,
  OptionalIncomeFieldsComponent,
  ...appModuleDeclarations // TODO
];
